<template>
  <div class="gameDeatil">
    <div class="gad_1">
      <img
        v-for="(item, index) in images"
        :key="index"
        :src="item"
        :id="'gad_1_' + index"
        class="gad_1_1"
      />
      <div class="gad_1_2">
        <img src="../../assets/gd/detail7.png" v-on:click="rollNext(this)" />
      </div>
      <div class="gad_1_3">
        <img src="../../assets/gd/detail8.png" v-on:click="rollLast(this)" />
      </div>
    </div>
    <div class="gad_2">
      <div class="gad_2_1">
        <div class="gad_2_11" v-html="testList[1]"></div>
        <div class="gad_2_12">{{ createTime }}</div>
      </div>
      <div class="gad_2_2">
        <div class="gad_2_21" v-html="testList[2]"></div>
        <div class="gad_2_22">{{ developers }}</div>
      </div>
      <div class="gad_2_3">
        <div v-for="(item, index) in types" :key="index">
          {{ item }}
        </div>
      </div>
      <p class="gad_2_4">
        {{ description }}
      </p>

      <a class="gad_2_5" :href="fileUrl">
        {{testList[3]}}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "gameDeatil",
  props: {
    createTime: String,
    developers: String,
    types: Array,
    description: String,
    images: Array,
    fileUrl: String,
    name: String,
    langType: String
  },
  watch: {
    langType: function (type) {
      this.changeLang(type);
    },
  },
  created() {
    //显示第几张图
    // this.rollIndex = -1;
    this.changeLang(this.$i18n.locale);
  },
  destroyed() {
    clearInterval(this.rollInterval);
  },
  mounted() {},
  updated() {
    this.rollIndex = -1;
    this.rollIndex++;
    this.changeRoll(this.rollIndex);
    this.setRollInterval();
  },
  methods: {
    download() {
      if(this.fileUrl == undefined || this.fileUrl == null){
        alert("暂不支持下载!")
        return
      }
      this.$download(this.fileUrl, {}, this.name);
    },
    changeRoll(index) {
      let classs = document.getElementsByClassName("gad_1_1");
      if (index >= classs.length) {
        this.rollIndex = 0;
        index = this.rollIndex;
      }
      if (index < 0) {
        this.rollIndex = classs.length - 1;
        index = this.rollIndex;
      }
      for (let i = 0; i < classs.length; i++) {
        if (i == index) {
          classs[i].style.display = "block";
        } else {
          classs[i].style.display = "none";
        }
      }
    },
    setRollInterval() {
      this.rollInterval = setInterval(() => {
        this.rollIndex++;
        this.changeRoll(this.rollIndex);
      }, 3000);
    },
    rollNext() {
      clearInterval(this.rollInterval);
      this.rollIndex++;
      this.changeRoll(this.rollIndex);
      this.setRollInterval();
    },
    rollLast() {
      clearInterval(this.rollInterval);
      this.rollIndex--;
      this.changeRoll(this.rollIndex);
      this.setRollInterval();
    },
    changeLang(type) {
      this.$post("/halababy/loofox/text", { pageNum: 12 }).then((res) => {
        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
  },
  data() {
    return {
      testList:[]
    };
  },
};
</script>

<style>
.gameDeatil {
  width: 100%;
  height: 100%;
  display: flex;
  background-color: white;
}
.gad_1 {
  width: 640px;
  height: 480px;
  position: relative;
  overflow: hidden;
}

.gad_1_1 {
  position: absolute;
  left:0; right:0; top:0; bottom:0;
  margin:auto;
  display: none;
  height: 100%;
}
.gad_1_2 {
  position: absolute;
  width: 44px;
  top: 0;
  left: 0;
  height: 480px;
  background: #000000;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.gad_1_3 {
  position: absolute;
  width: 44px;
  top: 0;
  right: -3px;
  height: 480px;
  background: #000000;
  opacity: 0.4;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.gad_2_1 {
  display: flex;
  margin-top: 32px;
  margin-left: 32px;
  line-height: 44px;
}
.gad_2_2 {
  display: flex;
  margin-top: 8px;
  margin-left: 32px;
  line-height: 44px;
}
.gad_2_11,
.gad_2_21 {
  height: 44px;
  text-align: center;
  width: 172px;
  background-image: url("../../assets/gd/detail4.png");
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #292929;
}
.gad_2_12,
.gad_2_22 {
  margin-left: 10px;
  height: 44px;
  width: 316px;
  padding-left: 33px;
  background: url("../../assets/gd/detail5.png") no-repeat;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #696969;
}
.gad_2_3 {
  display: flex;
  justify-content: start;
  flex-flow: wrap;
  width: 496px;
  height: 46px;
  margin-top: 16px;
  margin-left: 22px;
  line-height: 36px;
}
.gad_2_3 div {
  height: 36px;
  width: 100px;
  height: 36px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  text-align: center;
  margin-left: 10px;
  margin-top: 10px;
}
.gad_2_4 {
  margin-top: 20px;
  margin-left: 32px;
  width: 496px;
  height: 150px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #898989;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gad_2_5 {
  /* width: 240px; */
  text-decoration:none;
  padding: 20px 40px;
  height: 56px;
  background: #0ab1ff;
  border-radius: 5px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  border: none;
  margin-left: 32px;
  cursor: pointer;
}

.roll_l1 {
  position: absolute;
  top: 0;
  left: 0;
  animation: rolll1 2s ease 0s 1 alternate forwards;
  -webkit-animation: rolll1 2s ease 0s 1 alternate forwards;
}
.roll_l2 {
  position: absolute;
  top: 0;
  left: 640px;
  animation: rolll2 2s ease 0s 1 alternate forwards;
  -webkit-animation: rolll2 2s ease 0s 1 alternate forwards;
}
.roll_r1 {
  position: absolute;
  top: 0;
  left: 0;
  animation: rollr1 2s ease 0s 1 alternate forwards;
  -webkit-animation: rollr1 2s ease 0s 1 alternate forwards;
}
.roll_r2 {
  position: absolute;
  top: 0;
  left: -640px;
  animation: rollr2 2s ease 0s 1 alternate forwards;
  -webkit-animation: rollr2 2s ease 0s 1 alternate forwards;
}
</style>



// WEBPACK FOOTER //
// src/components/component/gameDetail.vue